import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export async function getClient(clientID) {
    let client = null;
    await axios.get(`${apiUrl}/getClient`, {params: {client_id: clientID}})
        .then(response => {
            client = response.data;
        }).catch(console.error);
    return client;
}

export async function activateClient(clientID) {
    let result = {error: true, message: "Unable to activate the store"};
    await axios.post(`${apiUrl}/activateClient`, null, {params: {client_id: clientID}})
        .then(response => {
            result.error = (response.data.status === "error");
            result.message = response.data.message;
        }).catch(console.error);
    return result;
}

export async function deactivateClient(clientID) {
    let result = {error: true, message: "Unable to deactivate the store"};
    await axios.post(`${apiUrl}/deactivateClient`, null, {params: {client_id: clientID}})
        .then(response => {
            result.error = (response.data.status === "error");
            result.message = response.data.message;
        }).catch(console.error);
    return result;
}
